/**
 * Hook table for the third mob roster (entities/mobs3): what a mob needs from
 * the EntityManager that is ticking it. EntityManager.bind() points it at
 * itself before every tick, so nothing here outlives a tick or assumes one
 * world: on a server each dimension's manager rebinds it in turn.
 */
import type { MobType } from '../../game/types';
import type { Mob } from '../mob';

export interface Mobs3Hooks {
  mobs(): readonly Mob[];
  spawn(type: MobType, x: number, y: number, z: number): Mob | null;
  /** One mob hurts another (damage, knockback, death and loot handled by the manager). */
  hurtMob(target: Mob, amount: number, from: Mob, knockback?: number): boolean;
  isHostile(type: MobType): boolean;
}

export const mobs3Hooks: Mobs3Hooks = {
  mobs: () => [],
  spawn: () => null,
  hurtMob: () => false,
  isHostile: () => false,
};

export const ri = (rnd: () => number, lo: number, hi: number): number => lo + Math.floor(rnd() * (hi - lo + 1));

/** Nearest living mob within `range` that passes `ok`. */
export function nearestMob(self: Mob, range: number, ok: (m: Mob) => boolean): Mob | null {
  let best: Mob | null = null, bd = range * range;
  for (const m of mobs3Hooks.mobs()) {
    if (m === self || !m.alive || !ok(m)) continue;
    const d = (m.x - self.x) ** 2 + (m.y - self.y) ** 2 + (m.z - self.z) ** 2;
    if (d < bd) { bd = d; best = m; }
  }
  return best;
}
